import axios from "@lib/axios";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export interface Inputs {
  emailId: string;
  filters: Record<string, any>;
}

interface HookProps {
  onSuccess?: (filepath: string) => void;
  onError?: (error: AxiosResponse) => void;
}

export const useEmailSentReport = ({ onSuccess, onError }: HookProps) => {
  const { mutate: onGenerateEmailSentReport, ...rest } = useMutation({
    mutationFn: async (data: Inputs) => {
      const {
        data: { filename },
      } = await axios.post("/reports/email-events", data);
      return filename;
    },
    onSuccess,
    onError,
  });

  return { onGenerateEmailSentReport, ...rest };
};
